import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { EditFilterRequestBody } from './types.tsx';

export const getEditFilterUrl = (filterId: string, overrideSharePermissions: boolean) =>
	`/rest/api/3/filter/${filterId}${
		overrideSharePermissions ? '?overrideSharePermissions=true' : ''
	}`;

const editRest = async (
	filterId: string,
	body: EditFilterRequestBody,
	overrideSharePermissions: boolean,
): Promise<void> => {
	const url = getEditFilterUrl(filterId, overrideSharePermissions);

	return performPutRequest(url, { body: JSON.stringify(body) });
};

export default editRest;
